export const TOOL_TASK = 'unassign-user-entitlements';
export const TOOL_TITLE = 'Unassign User Resources';
export const TOOL_PROGRESS_LABEL = 'Progress of unassigning resources from the user...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once unassigning resources from the user finishes';
export const MODAL_WIDTH = 800;
